import configs from '@/config'
import { createSharedFramePersistence, sharedFrameStorage } from '@/utils/indexedDB/shared-frame-cache.persistence'
import { isOfflinePresentingStoredOn } from '@/services/offlinePresentingFlag'

// Bumped when a persisted response changes shape; never tied to the release build, so a deploy keeps saved copies.
export const OFFLINE_CACHE_SCHEMA_VERSION = 'v1'

// The gate for every cache entry persisted across page loads: shared between same-origin PowerPoint
// add-in frames, and the offline-presenting copies. Callers pass this as SimpleCache's
// `persistence` and check the gate before opting a call in.
export const isSharedFrameCacheEnabled = () => Boolean(configs.isEnableAddinPowerpoint) || isOfflinePresentingStoredOn()

export const sharedFramePersistence = createSharedFramePersistence({
  storage: sharedFrameStorage,
  isEnabled: isSharedFrameCacheEnabled,
  schemaVersion: OFFLINE_CACHE_SCHEMA_VERSION,
})

export const SAVED_PROFILE_KEY = 'getUser'

export const clearSavedProfiles = async () => {
  try {
    await sharedFramePersistence.removeInEveryScope(SAVED_PROFILE_KEY)
  } catch (error) {
    // Intentionally ignored: sign-out must go on when IndexedDB is unavailable.
  }
}
